import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';

export function PwaInstallBanner() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [isVisible, setIsVisible] = useState(false);
  const [isRendered, setIsRendered] = useState(false);

  useEffect(() => {
    const hasDismissed = sessionStorage.getItem('pwa_banner_dismissed');

    const handleBeforeInstallPrompt = (e) => {
      // Previne que o Chrome exiba o prompt padrão
      e.preventDefault();
      // Guarda o evento para ser disparado pelo nosso botão
      setDeferredPrompt(e);
      
      if (!hasDismissed) {
        setIsRendered(true);
        // Pequeno atraso para a animação de slide-down funcionar corretamente ao montar
        setTimeout(() => setIsVisible(true), 100);
      }
    };

    // 1. Resgata o evento se ele já foi capturado globalmente (pelo index.html) antes do React montar
    if (window.deferredPWAInstallPrompt) {
      handleBeforeInstallPrompt(window.deferredPWAInstallPrompt);
    }

    const handleAppInstalled = () => {
      console.log('App instalado nativamente!');
      setDeferredPrompt(null);
      setIsVisible(false);
      setTimeout(() => setIsRendered(false), 500);
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    window.addEventListener('appinstalled', handleAppInstalled);

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
      window.removeEventListener('appinstalled', handleAppInstalled);
    };
  }, []);

  const handleInstallClick = async () => {
    setIsVisible(false);
    setTimeout(() => setIsRendered(false), 500);
    
    if (deferredPrompt) {
      // Exibe o prompt nativo do navegador
      deferredPrompt.prompt();
      // Aguarda a resposta do usuário
      const { outcome } = await deferredPrompt.userChoice;
      console.log(`Resultado da instalação: ${outcome}`);
      setDeferredPrompt(null);
    }
  };

  const handleDismiss = () => {
    sessionStorage.setItem('pwa_banner_dismissed', 'true');
    setIsVisible(false);
    setTimeout(() => setIsRendered(false), 500);
  };

  if (!isRendered) return null;

  return (
    <div 
      className={`fixed top-0 left-0 w-full z-[9999] bg-green-900 dark:bg-card text-white p-3 shadow-xl flex items-center justify-between gap-3 transition-transform duration-500 ease-out ${isVisible ? 'translate-y-0' : '-translate-y-full'}`}
    >
      <div className="flex items-center gap-3 flex-1 overflow-hidden">
        <img src="/logo192.png" className="w-10 h-10 rounded-lg bg-white p-1 shrink-0 shadow-sm" alt="Icone do Gestão Timbó" />
        <div className="flex flex-col truncate">
          <span className="font-bold text-sm text-white">Instale o Gestão Timbó</span>
          <span className="text-xs text-green-100 dark:text-gray-400 truncate">Mais rápido e não ocupa espaço</span>
        </div>
      </div>
      <div className="flex items-center gap-2 shrink-0">
        <button 
          onClick={handleInstallClick} 
          className="px-4 py-1.5 bg-white text-green-900 dark:bg-white dark:text-card text-sm font-bold rounded-full hover:bg-green-50 active:scale-95 transition-all shadow-sm"
        >
          Instalar
        </button>
        <button 
          onClick={handleDismiss} 
          className="p-1.5 text-white/80 hover:text-white rounded-full transition-colors flex items-center justify-center"
        >
          <X className="w-5 h-5" />
        </button>
      </div>
    </div>
  );
}
